import { render, staticRenderFns } from "./Creditcard.vue?vue&type=template&id=3c1c856d&scoped=true&"
import script from "./Creditcard.vue?vue&type=script&lang=ts&"
export * from "./Creditcard.vue?vue&type=script&lang=ts&"
import style0 from "./Creditcard.vue?vue&type=style&index=0&id=3c1c856d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c856d",
  null
  
)

export default component.exports